import { useState } from 'react'

export type UseFloatingSaveProps = {
  isDirtyForm: boolean
  handleSaveConfiguration?: () => void | Promise<void>
}

export type UseFloatingSaveReturn = {
  visible: boolean
  isSaving: boolean
  buttonType: 'button' | 'submit'
  onSave: (() => void) | undefined
}

export function useFloatingSave({ isDirtyForm, handleSaveConfiguration }: UseFloatingSaveProps): UseFloatingSaveReturn {
  const [isSaving, setIsSaving] = useState(false)

  // The save settling is what ends the spinner. A handler that returns early on a
  // rejected mutation never clears the dirty flag, so form state cannot end it.
  const onSave = handleSaveConfiguration
    ? async () => {
        setIsSaving(true)
        try {
          await handleSaveConfiguration()
        } finally {
          setIsSaving(false)
        }
      }
    : undefined

  return {
    visible: isDirtyForm,
    isSaving,
    buttonType: handleSaveConfiguration ? `button` : `submit`,
    onSave,
  }
}
